import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TuiTextfieldControllerModule, TuiInputModule, TuiMultiSelectModule } from '@taiga-ui/legacy';
import { TuiDataListWrapper, TuiAvatar } from '@taiga-ui/kit';
import {
  TuiDataList,
  TuiLoader,
  TuiScrollbar,
  TuiScrollable,
  TuiFallbackSrcPipe,
  TuiInitialsPipe,
  TuiAutoColorPipe,
} from '@taiga-ui/core';
import { TuiAutoFocus, TuiLet } from '@taiga-ui/cdk';
import { SharedModule } from '@src/app/shared';
import { UsersListModule } from '@src/app/modules/users-list';
import { IconModule } from '@src/app/modules/icon';
import { ComponentsModule } from '@src/app/components';

import { GroupComponent } from './group.component';

@NgModule({
  declarations: [GroupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TuiAutoFocus,
    TuiAvatar,
    ...TuiDataList,
    ...TuiDataListWrapper,
    TuiInputModule,
    TuiLet,
    TuiLoader,
    TuiMultiSelectModule,
    TuiScrollbar,
    TuiScrollable,
    TuiTextfieldControllerModule,
    UsersListModule,
    IconModule,
    ComponentsModule,
    TuiFallbackSrcPipe,
    TuiInitialsPipe,
    TuiAutoColorPipe,
  ],
  exports: [GroupComponent],
})
export class GroupModule {}
